import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../Activities/Activity.css";

const Activity = () => {

const [activitydata,setActivityData] = useState([]);
const [visibleCount,setVisibleCount] = useState(6);
const [selectedEvent,setSelectedEvent] = useState(null);
const [selectedIndex,setSelectedIndex] = useState(null);
const [search,setSearch] = useState("");
const [year,setYear] = useState("All");
const [category,setCategory] = useState("All");

/* ✅ NEW: ZOOM STATE */
const [zoomImage,setZoomImage] = useState(null);


/* DATE PARSER */

const parseDate = (dateStr) => {

if(!dateStr) return null;

const parts = dateStr.split("-");
if(parts.length !== 3) return null;

const day = parseInt(parts[0],10);
const month = parseInt(parts[1],10) - 1;
const year = parseInt(parts[2],10);

return new Date(year,month,day);

};


/* FETCH DATA */

useEffect(()=>{

axios
.get("/api/activities")
.then(res=>{
setActivityData(res.data);
})
.catch(err=>{
console.error("Error loading activities",err);
});

},[]);


/* EXTRACT YEARS */

const years = [
"All",
...new Set(
activitydata
.map(item=>{
if(!item.evdate) return null;
const parts = item.evdate.split("-");
return parts[2];
})
.filter(Boolean)
)
];


/* FILTER */

const filteredEvents = activitydata
.filter(event=>{

if(!event.evdate) return false;

const parts = event.evdate.split("-");
const eventYear = parseInt(parts[2]);

const matchSearch =
event.evtitle
.toLowerCase()
.includes(search.toLowerCase());

const matchYear =
year==="All" || eventYear===parseInt(year);

const matchCategory =
category==="All" || event.category===category;

const currentYear = new Date().getFullYear();
const hideOld = eventYear >= currentYear - 3;

return matchSearch && matchYear && matchCategory && hideOld;

})
.sort((a,b)=>{

const da = parseDate(a.evdate);
const db = parseDate(b.evdate);

if(!da || !db) return 0;

return db - da;

});


const visibleEvents = filteredEvents.slice(0,visibleCount);

const loadMore = ()=>setVisibleCount(prev=>prev+6);


/* DATE FORMAT */

const formatDate = (dateStr) => {

const d = parseDate(dateStr);
if(!d) return dateStr;

return d.toLocaleDateString("en-IN",{
day:"2-digit",
month:"long",
year:"numeric"
});

};


/* UPCOMING */

const isUpcoming = (dateStr) => {

const eventDate = parseDate(dateStr);
if(!eventDate) return false;

const today = new Date();
today.setHours(0,0,0,0);

return eventDate > today;

};

const isNewEvent = (dateStr) => {

return isUpcoming(dateStr);

};


/* OPEN MODAL */

const openModal = (event,index) => {

setSelectedEvent(event);
setSelectedIndex(index);

};


/* CLOSE MODAL */

const closeModal = () => {

setSelectedEvent(null);
setSelectedIndex(null);

};


/* NEXT EVENT */

const nextEvent = () => {

if(selectedIndex < visibleEvents.length - 1){

const newIndex = selectedIndex + 1;

setSelectedIndex(newIndex);
setSelectedEvent(visibleEvents[newIndex]);

}

};


/* PREVIOUS EVENT */

const prevEvent = () => {

if(selectedIndex > 0){

const newIndex = selectedIndex - 1;

setSelectedIndex(newIndex);
setSelectedEvent(visibleEvents[newIndex]);

}

};


/* ESC + KEYBOARD NAVIGATION */

useEffect(()=>{

    const handleKey = (e) => {
    
    /* ✅ FIX: ESC handles zoom first */
    if(e.key === "Escape"){
        if(zoomImage){
            setZoomImage(null);
            return;
        }
        closeModal();
    }

    if(!selectedEvent) return;

    if(e.key === "ArrowRight") nextEvent();
    if(e.key === "ArrowLeft") prevEvent();
    };
    
    window.addEventListener("keydown",handleKey);
    return ()=>window.removeEventListener("keydown",handleKey);
});


return(

<div className="container activity-container">

{/* HERO */}

<div className="activity-hero">

<h1>SCHOOL ACTIVITIES & UPCOMING EVENTS</h1>

<p>
Explore competitions, sports events, cultural programs
and memorable school celebrations.
</p>

</div>


{/* FILTER */}

<div className="activity-filter">

<input
type="text"
placeholder="Search activity..."
className="form-control activity-search"
value={search}
onChange={(e)=>setSearch(e.target.value)}
/>

<select
className="form-select activity-year"
value={year}
onChange={(e)=>setYear(e.target.value)}
>

{years.map((y,i)=>(

<option key={i}>{y}</option>

))}

</select>

<select
className="form-select activity-category"
value={category}
onChange={(e)=>setCategory(e.target.value)}
>

<option>All</option>
<option>National Event</option>
<option>Festival</option>
<option>Function</option>
<option>Sports</option>
<option>School</option>
<option>Class</option>
<option>Laboratory</option>
<option>Library</option>
<option>Computer</option>
<option>Competition</option>
<option>Seminar</option>
<option>Workshop</option>
<option>Social Activity</option>
<option>Farewell</option>
<option>Party</option>
<option>Tour</option>
<option>Academic</option>
<option>Cultural</option>
<option>Advertisement</option>
<option>Others</option>

</select>

</div>


{/* GRID */}

<div className="row g-4">

{visibleEvents.map((event,index)=>(

<div key={index} className="col-12 col-sm-6 col-lg-4">

<div
className="card activity-card h-100"
onClick={()=>openModal(event,index)}
>

<img
src={`${BASE_URL}/uploads/activities/${event.imgpic}`}
loading="lazy"
alt=""
className="activity-img"
/>

<div className="card-body">

<h5 className="card-title clamp-title">

{event.evtitle}

{isNewEvent(event.evdate) && (

<span className="badge-new">
NEW
</span>

)}

</h5>

<div className="event-meta">

<span className="badge-date">
{formatDate(event.evdate)}
</span>

<span className="event-category">
{event.category}
</span>

{isUpcoming(event.evdate) && (

<span className="badge-upcoming">
Upcoming
</span>

)}

</div>

<p className="card-text clamp-desc">
{event.evremark}
</p>

<button className="btn btn-primary read-btn">
Read More...
</button>

</div>

</div>

</div>

))}

</div>


{/* LOAD MORE */}

{visibleCount < filteredEvents.length && (

<div className="text-center loadmore-wrapper">

<button
className="btn btn-outline-primary load-btn"
onClick={loadMore}
>

Load More Activities

</button>

</div>

)}


{/* MODAL */}

{selectedEvent && (

<div
className="modal-overlay"
onClick={closeModal}
>

<div
className="activity-modal"
onClick={(e)=>e.stopPropagation()}
>

<button
className="modal-close"
onClick={closeModal}
>
×
</button>


{/* NAV BUTTONS */}
{selectedIndex > 0 && (
<button className="modal-prev" onClick={prevEvent}>❮</button>
)}

{selectedIndex < visibleEvents.length - 1 && (
<button className="modal-next" onClick={nextEvent}>❯</button>
)}

<div className="modal-content-wrapper">

<div className="modal-left">

{/* ✅ CLICK TO ZOOM */}
<img
src={`${BASE_URL}/uploads/activities/${selectedEvent.imgpic}`}
alt=""
onClick={()=>setZoomImage(`${BASE_URL}/uploads/activities/${selectedEvent.imgpic}`)}
style={{cursor:"zoom-in"}}
/>

</div>

<div className="modal-right">

<h4 className="modal-title">
{selectedEvent.evtitle}
</h4>

<div className="modal-date">
{formatDate(selectedEvent.evdate)}
</div>

<div className="modal-text">
  <div className="modal-text-inner">
    {selectedEvent.evremark}
  </div>
</div>

{/* <button
className="btn btn-secondary modal-btn"
onClick={closeModal}
>
Close
</button> */}

</div>

</div>

</div>

</div>

)}

{/* ✅ ZOOM OVERLAY */}
{zoomImage && (
<div className="zoom-overlay" onClick={()=>setZoomImage(null)}>
<img src={zoomImage} alt="" />
</div>
)}

</div>

)

}

export default Activity;